// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__2rgYV","label":"Checkbox_label__XzZAT","span":"Checkbox_span__uaJQb"};